module.exports = __webpack_public_path__ + "static/media/A15.4939ec8e.jpg";